import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const HomeFeaturedArticles = () => {
  return (
    <div className="home-articles mt-4">
      <h4 className="text-center"> 注目の記事 </h4>
      <div className="row">
        {/*  */}
        <div className="article-wrapper home-articles-post col-lg-3 col-6">
          <a
            title={`【特集 第一弾】"ウェブ業界のデンマーク” 株式会社メンバーズの幸せな働き方 徹底解明！`}
            href="https://www.clarity.tokyo/company/500/interview/2/">
            <div className="row mx-0">
              <div className="col-12 px-0 mx-0 article-thumbnail">
                <img
                  alt=""
                  src="https://storage.googleapis.com/clarity-interview-article-images/1575895849-L1002706.jpg"
                  className="img-fluid"
                />
              </div>
              <div className="col-12 px-0 mx-0 text-justify">
                <span className="article-tag">
                  <small>インタビュー</small>
                </span>
                <div className="article-title mt-2">
                  【特集
                  第二弾】「自分がどこまでやれるか見極め、個の限界をチームワークで...
                </div>
              </div>
            </div>
          </a>
        </div>

        {/*  */}
        <div className="article-wrapper home-articles-post col-lg-3 col-6">
          <a
            title={`世界最多の感染都市ニューヨークで生き抜く女性起業家から学ぶ、withコロナのヘルシーなサバイバル術`}
            href="https://www.clarity.tokyo/articles/ibentorepo/ny-corona-1/">
            <div className="row mx-0">
              <div className="col-12 px-0 mx-0 article-thumbnail">
                <img
                  alt=""
                  src="https://www.clarity.tokyo/articles/content/images/2020/05/iStock-1063392686-2.jpg"
                  className="img-fluid"
                />
              </div>
              <div className="col-12 px-0 mx-0 text-justify">
                <span className="article-tag">
                  <small>イベントレポ</small>
                </span>
                <div className="article-title mt-2">
                  世界最多の感染都市ニューヨークで生き抜く女性起業家から学ぶ、
                </div>
              </div>
            </div>
          </a>
        </div>
        {/* AWS */}
        <div className="article-wrapper home-articles-post col-lg-3 col-6">
          <a
            title={`社員主体の「MEMBERS WAY委員会」が実現する、株式会社メンバーズの全員参加型経営とは？`}
            href="https://www.clarity.tokyo/company/500/interview/3/">
            <div className="row mx-0">
              <div className="col-12 px-0 mx-0 article-thumbnail">
                <img
                  alt="member"
                  src="https://storage.googleapis.com/clarity-interview-article-images/1577250471-L1002855.jpg"
                  className="img-fluid"
                />
              </div>
              <div className="col-12 px-0 mx-0 text-justify">
                <span className="article-tag">
                  <small>インタビュー</small>
                </span>
                <div className="article-title mt-2">
                  【特集
                  第三弾】社員主体の「MEMBERSWAY委員会」が実現する、株式会...
                </div>
              </div>
            </div>
          </a>
        </div>
        {/*  */}
        <div className="article-wrapper home-articles-post col-lg-3 col-6">
          <a
            title={`【特集 第一弾】"ウェブ業界のデンマーク” 株式会社メンバーズの幸せな働き方 徹底解明！`}
            href="https://www.clarity.tokyo/company/500/interview/1/">
            <div className="row mx-0">
              <div className="col-12 px-0 mx-0 article-thumbnail">
                <img
                  alt="member"
                  src="https://storage.googleapis.com/clarity-interview-article-images/1569477000-L1002488%20(1).jpg"
                  className="img-fluid"
                />
              </div>
              <div className="col-12 px-0 mx-0 text-justify">
                <span className="article-tag">
                  <small>インタビュー</small>
                </span>
                <div className="article-title mt-2">
                  【特集 第一弾】"ウェブ業界のデンマーク”
                  株式会社メンバーズの幸せな働き方...
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeFeaturedArticles;
